import React from "react";

import classes from "./Subtitle.module.css";

export default function Subtitle() {
  return (
    <article className={classes.center}>
      <h3 className={classes.subtitleText}>
        גידול ושיווק כל סוגי הפרחים, הצמחים והציוד הנלווה – מפעל סיטונאי לזרי
        פרחים,
        <br className={classes.newLine} />
        באיכות וטריות ללא פשרות.
        <br />
        רחוב הסדנא 8, חולון – רמה אחת מעל כולם!
      </h3>
    </article>
  );
}
